<template>
  <b-container>
    <b-row>
      <b-col class="mb-5 pb-5">
        <h4 class="text-center">404</h4>
        <p class="text-center">Страница, которую Вы ищите не существует. Нам очень жаль.</p>
        <div class="text-center mt-5">
          <!-- <b-link @click.prevent="$router.go(-1)">Назад</b-link> -->
          <b-link :to="{ name: 'home' }">На главную</b-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data: () => ({})
}
</script>

<style lang="scss" scoped>
h4 {
  font-size: 8rem;

  background-color: rgb(100,100,100);
  background-clip: text;
  color: transparent;
  text-shadow: rgba(255,255,255,0.6) 0px 3px 3px;
}
p {
  font-size: .92rem;
  color: rgb(100,100,100);
  text-transform: uppercase;
}
</style>
